module.exports = __webpack_public_path__ + "img/3-questions.6b3253c2.svg";